import React, { Component } from "react";
import { Tooltip } from "@mui/material";
import { withStyles } from "@mui/styles";
import styles from "./box-layout.styles";
import BOX_TYPE from "../enum/box_type";
import "./index.css";
import { withTranslation } from "react-i18next";
import groupTypes from "../common/group-types";
import LockIcon from "@mui/icons-material/Lock";

let nums1 = Array.from(Array(12).keys());
let nums3 = Array.from(Array(3).keys());
let BinIds = [];
let deactivatedBin = [];
let IsSaved;

export class C30Layout extends Component {
  componentDidMount() {
    // Debug: Log props to verify columnMappings and userGroupType are being passed
    console.log('[C30Layout] componentDidMount - Props:', {
      hasColumnMappings: !!this.props.columnMappings,
      columnMappings: this.props.columnMappings,
      columnMappingsType: Array.isArray(this.props.columnMappings),
      columnMappingsLength: this.props.columnMappings ? this.props.columnMappings.length : 0,
      userGroupType: this.props.userGroupType,
      allProps: Object.keys(this.props)
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.columnMappings !== this.props.columnMappings || prevProps.userGroupType !== this.props.userGroupType) {
      console.log('[C30Layout] componentDidUpdate - Props changed:', {
        hasColumnMappings: !!this.props.columnMappings,
        columnMappings: this.props.columnMappings,
        userGroupType: this.props.userGroupType
      });
    }
  }

  handleChangeIndex = (index) => {
    this.setState({
      selectedUnit: index,
    });
    this.props.getSelectedUnitName(index);
  };

  componentWillReceiveProps() {
    const { deactivatedBins } = this.props;
    if (deactivatedBins && deactivatedBins.length > 0) {
      deactivatedBins.map((item) => {
        if (item) {
          deactivatedBin.push(item);
          let node = document.getElementById(item);
          if (node !== null && node !== undefined) {
            let x = node.parentNode.classList && node.parentNode.classList[2];
            node.parentNode.classList.remove(x);
            let items = document.getElementById(item);
            if (items && items.style) {
              items.style.background =
                "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)";
              items.style.color = "#fff";
              items.style.cursor = "pointer";
            }
          }
        }
        return true;
      });
    } else {
      deactivatedBin.map((item) => {
        if (item) {
          var items = document.getElementById(item);
          if (items && items.style) {
            items.style.background =
              "linear-gradient(148deg, #ffffff 30%, #d9dcdb 60%, #dcdcdc 87%)";
            items.style.color = "#000";
            items.style.cursor = "pointer";
            items.style.pointerEvents = "all";
          }
        }
        return true;
      });
      deactivatedBin = [];
    }
  }

  checkIsSaved = (binId) => {
    if (this.props && this.props.BinStatus.length > 0) {
      this.props.BinStatus.map((binitem) => {
        if (binitem.bin_id === binId) {
          IsSaved = true;
        } else {
          IsSaved = false;
        }
        return true;
      });
    } else {
      IsSaved = false;
    }
  };
  openbin = (binId, status, pm_id) => {
    // Check if bin is restricted by column mapping - don't allow opening if restricted
    if (this.isRestrictedByColumnMapping(binId)) {
      console.log('[C30] openbin blocked - bin is restricted by column mapping:', binId);
      return; // Don't allow opening if restricted by column mapping
    }
    
    // Also check combined restriction (group type + column mapping)
    if (this.isRestricted(null, binId)) {
      console.log('[C30] openbin blocked - bin is restricted (combined check):', binId);
      return;
    }
    
    if (status === "Assigned" || status === "Stocked" || status === "Hold") {
      if (this.props.deactivatedBins.includes(binId)) {
        this.props.Selectedbin(binId, this.props.box_position);
        let items = document.getElementById(binId);
        items.style.background =
          "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)"; // deavtivated
        items.style.color = "#ffffff";
      }
      this.props.getPrescriptionDetails(binId, pm_id);
    } else {
      // Handle deactivated bins without status - allow activation
      if (this.props.deactivatedBins.includes(binId)) {
        this.props.Selectedbin(binId, this.props.box_position);
        this.props.getPrescriptionDetails(binId, pm_id);
        let items = document.getElementById(binId);
        if (items) {
          items.style.background =
            "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)"; // deavtivated
          items.style.color = "#ffffff";
        }
      } else {
        BinIds.map((item) => {
          this.checkIsSaved(item);
          if (item !== binId && IsSaved === false) {
            var items = document.getElementById(item);
            items.style.background =
              "linear-gradient(148deg, #ffffff 30%, #d9dcdb 60%, #dcdcdc 87%)";
          }
          return true;
        });
        BinIds = [];
        BinIds.push(binId);
        if (BinIds.length > 0) {
          this.props.Selectedbin(binId, this.props.box_position);
          var items = document.getElementById(binId);
          items.style.background =
            "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(253, 253, 2) 90%)";
        }
      }
    }
  };

  getColumns = (
    currentIndex,
    currentColumnCount,
    previousColumnCount,
    side
  ) => {
    let columns = [];
    if (side === "L") {
      for (
        let i = previousColumnCount + currentColumnCount;
        i > previousColumnCount;
        i--
      ) {
        columns.push(
          String.fromCharCode(65 + (i - 1)) + String.fromCharCode(65 + (i - 1))
        );
      }
    } else {
      for (
        let i = previousColumnCount;
        i < previousColumnCount + currentColumnCount;
        i++
      ) {
        columns.push(String.fromCharCode(65 + (i - 1)));
      }
    }
    return columns;
  };

  getCurrentAndPreviousPosition = (side) => {
    const { expansion, ExpansionsCounts, boxTypeId } = this.props;
    let response = {};
    response.currentCount = expansion.bin_column_count;
    if (side === "L") {
      let _expansionsCount =
        ExpansionsCounts && ExpansionsCounts.leftExpansions;
      if (expansion.box_position === -1 || expansion.box_position === "-1") {
        response.previousCount = 0;
      } else {
        response.previousCount = this.excludeCurrentExpansion(
          expansion,
          _expansionsCount
        );
      }
    } else {
      let _expansionsCount = ExpansionsCounts.rightExpansions;
      if (expansion.box_position === 1 || expansion.box_position === "1") {
        if (boxTypeId === BOX_TYPE.Locker) {
          response.previousCount = 6;
        } else {
          response.previousCount = 4;
        }
      } else {
        if (boxTypeId === BOX_TYPE.Locker) {
          response.previousCount =
            this.excludeCurrentExpansion(expansion, _expansionsCount) + 6;
        } else {
          response.previousCount =
            this.excludeCurrentExpansion(expansion, _expansionsCount) + 4;
        }
      }
    }
    return response;
  };

  excludeCurrentExpansion = (expansion, expansionArray) => {
    let currentUnitIndex = null;
    let sumOfColumns = 0;
    for (let index = 0; index < expansionArray.length; index++) {
      if (expansionArray[index].expansionId === expansion.id) {
        currentUnitIndex = index;
        break;
      }
    }
    for (let i = 0; i < currentUnitIndex; i++) {
      if (expansionArray[i - 1] !== undefined) {
        sumOfColumns =
          expansionArray[i].bin_column_count +
          expansionArray[i - 1].bin_column_count;
      } else {
        sumOfColumns = expansionArray[i].bin_column_count;
      }
    }
    return sumOfColumns;
  };

  // Check if bin is restricted by group type (existing logic)
  isRestrictedByGroupType = (groupTypeId) => {
    return [
      groupTypes.Retail,
      groupTypes.Super,
      groupTypes.eCommerce,
      groupTypes.Audiology,
    ].includes(groupTypeId)
      ? true
      : false;
  };

  // Extract column ID from bin ID (e.g., "A1" -> "A", "AA1" -> "AA", "A1-A12" -> "A")
  getColumnIdFromBinId = (binId) => {
    if (!binId) return null;
    // Handle formats like "A1", "AA1", "A1-A12", "AA1-AA12"
    const match = binId.match(/^([A-Z]+)\d+/);
    return match ? match[1] : null;
  };

  // Check if bin is restricted by column mappings
  isRestrictedByColumnMapping = (binId) => {
    const { columnMappings, userGroupType } = this.props;
    
    // If no column mappings, not restricted
    if (!columnMappings || !Array.isArray(columnMappings) || columnMappings.length === 0) {
      return false;
    }
    
    // If no user group type, check if column is mapped to ANY group (restrict if mapped)
    // This handles the case where user is Super Admin or has no specific group
    // For Super Admin, we might want to allow all, but for now, if a column is mapped, it's restricted for users without a group
    if (!userGroupType) {
      // Extract column ID from bin ID
      const columnId = this.getColumnIdFromBinId(binId);
      if (!columnId) return false;
      
      // Check if this column is mapped to any group - if yes, restrict it
      const columnMapping = columnMappings.find(mapping => {
        if (!mapping || !mapping.column_id) return false;
        const mappingColumnId = this.getColumnIdFromBinId(mapping.column_id);
        return mappingColumnId === columnId;
      });
      
      // If column is mapped but user has no group type, restrict it
      if (columnMapping && columnMapping.group_type_id) {
        return true;
      }
      return false;
    }

    // Extract column ID from bin ID
    const columnId = this.getColumnIdFromBinId(binId);
    if (!columnId) {
      return false;
    }

    // Find the column mapping for this column
    // Column mappings format: [{ column_id: "A1-A12", group_type_id: "..." }]
    // We need to check if the column ID matches (e.g., "A" matches "A1-A12")
    const columnMapping = columnMappings.find(mapping => {
      if (!mapping || !mapping.column_id) return false;
      // Extract column letter from mapping (e.g., "A1-A12" -> "A")
      const mappingColumnId = this.getColumnIdFromBinId(mapping.column_id);
      return mappingColumnId === columnId;
    });

    // If column is mapped to a different group than user's group, it's restricted
    if (columnMapping && columnMapping.group_type_id && columnMapping.group_type_id !== userGroupType) {
      return true;
    }

    return false;
  };

  // Combined check: restricted by group type OR column mapping
  isRestricted = (groupTypeId, binId) => {
    // First check existing group type restriction
    if (this.isRestrictedByGroupType(groupTypeId)) {
      return true;
    }
    // Then check column mapping restriction
    if (this.isRestrictedByColumnMapping(binId)) {
      return true;
    }
    return false;
  };

  renderCell = (
    BinStatus,
    binType,
    binKey,
    pm_id,
    statusClass,
    statusTitle,
    disableClass,
    isdisabledDoor
  ) => {
    const { isViewPermissionAllowed } = this.props;
    return (
      <td
        key={binKey}
        className={isdisabledDoor ? disableClass : undefined}
        style={{
          padding: "4px",
          width: "85px",
          pointerEvents: this.isRestricted(
            BinStatus && BinStatus.group_type_id,
            binKey
          )
            ? "none"
            : isViewPermissionAllowed
            ? "auto"
            : "none",
          cursor: this.isRestricted(BinStatus && BinStatus.group_type_id, binKey)
            ? "not-allowed"
            : isViewPermissionAllowed
            ? "pointer"
            : "not-allowed",
        }}
        onClick={(e) => {
          // Double-check restriction before opening
          if (this.isRestricted(BinStatus && BinStatus.group_type_id, binKey)) {
            console.log('[C30] Click blocked - bin is restricted:', binKey);
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          this.openbin(binKey, binType, pm_id);
        }}
      >
        <Tooltip key={binKey} title={statusTitle}>
            <div
              id={binKey}
              className={statusClass}
              style={{ 
                boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
                borderRadius: '4px',
                                                                        // Apply visual styling for column-restricted bins
                                                                        backgroundColor: this.isRestrictedByColumnMapping(binKey) ? '#FFE0B2' : 'transparent',
                                                                        border: this.isRestrictedByColumnMapping(binKey) ? '2px solid #FF9800' : 'none',
              }}
            >
              {this.isRestricted(BinStatus && BinStatus.group_type_id, binKey) && (
                <LockIcon fontSize="12px" />
              )}
              &nbsp;{binKey}
            </div>
        </Tooltip>
      </td>
    );
  };

  renderMiddleColumnCells = (
    n,
    n1,
    elem3,
    BinStatus,
    binType,
    binKey,
    pm_id,
    statusClass,
    statusTitle,
    disableClass,
    isdisabledDoor,
  ) => {
    const { isViewPermissionAllowed } = this.props;
    if (n === 1 && n1 === 0) {
      return (
        <td
          key={binKey}
          className={isdisabledDoor ? disableClass : undefined}
          rowSpan={2}
          style={{
            padding: "4px",
            width: "85px",
            height: "90px",
            pointerEvents: this.isRestricted(
              BinStatus && BinStatus.group_type_id,
              binKey
            )
              ? "none"
              : isViewPermissionAllowed
              ? "auto"
              : "none",
            cursor: this.isRestricted(BinStatus && BinStatus.group_type_id, binKey)
              ? "not-allowed"
              : isViewPermissionAllowed
              ? "pointer"
              : "not-allowed",
          }}
          onClick={(e) => {
            const binId = elem3[n] + "" + (n1 + 1);
            // Double-check restriction before opening
            if (this.isRestricted(BinStatus && BinStatus.group_type_id, binId)) {
              console.log('[C30] Click blocked - bin is restricted:', binId);
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            this.openbin(binId, binType, pm_id);
          }}
        >
          <Tooltip key={elem3[n] + "" + (n1 + 1)} title={statusTitle}>
            <div
              id={elem3[n] + "" + (n1 + 1)}
              className={statusClass}
              style={{
                height: "90px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
                borderRadius: '4px',
                                                                        // Apply visual styling for column-restricted bins
                                                                        backgroundColor: this.isRestrictedByColumnMapping(elem3[n] + "" + (n1 + 1)) ? '#FFE0B2' : 'transparent',
                                                                        border: this.isRestrictedByColumnMapping(elem3[n] + "" + (n1 + 1)) ? '2px solid #FF9800' : 'none',
              }}
            >
              {this.isRestricted(BinStatus && BinStatus.group_type_id, elem3[n] + "" + (n1 + 1)) && (
                <LockIcon fontSize="12px" />
              )}
              &nbsp;{elem3[n] + "" + (n1 + 1)}
            </div>
          </Tooltip>
        </td>
      );
    }
    if (n === 1 && n1 === 2) {
      return (
        <td
          key={binKey}
          className={isdisabledDoor ? disableClass : undefined}
          rowSpan={2}
          style={{
            padding: "4px",
            width: "85px",
            height: "90px",
            pointerEvents: this.isRestricted(
              BinStatus && BinStatus.group_type_id,
              binKey
            )
              ? "none"
              : isViewPermissionAllowed
              ? "auto"
              : "none",
            cursor: this.isRestricted(BinStatus && BinStatus.group_type_id, binKey)
              ? "not-allowed"
              : isViewPermissionAllowed
              ? "pointer"
              : "not-allowed",
          }}
          onClick={(e) => {
            const binId = elem3[n] + "" + n1;
            // Double-check restriction before opening
            if (this.isRestricted(BinStatus && BinStatus.group_type_id, binId)) {
              console.log('[C30] Click blocked - bin is restricted:', binId);
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            this.openbin(binId, binType, pm_id);
          }}
        >
          <Tooltip key={elem3[n] + "" + n1} title={statusTitle}>
            <div
              id={elem3[n] + "" + n1}
              className={statusClass}
              style={{
                height: "90px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
                borderRadius: '4px',
                // Apply different styling for column-restricted bins
                backgroundColor: this.isRestrictedByColumnMapping(elem3[n] + "" + n1) ? '#FFE0B2' : 'transparent',
                border: this.isRestrictedByColumnMapping(elem3[n] + "" + n1) ? '2px solid #FF9800' : 'none',
              }}
            >
              {this.isRestricted(BinStatus && BinStatus.group_type_id, elem3[n] + "" + n1) && (
                <LockIcon fontSize="12px" />
              )}
              &nbsp;{elem3[n] + "" + n1}
            </div>
          </Tooltip>
        </td>
      );
    }
    if (n === 1 && [4, 5].includes(n1)) {
      return (
        <td
          key={binKey}
          className={isdisabledDoor ? disableClass : undefined}
          style={{
            padding: "4px",
            width: "85px",
            pointerEvents: this.isRestricted(
              BinStatus && BinStatus.group_type_id,
              binKey
            )
              ? "none"
              : isViewPermissionAllowed
              ? "auto"
              : "none",
            cursor: this.isRestricted(BinStatus && BinStatus.group_type_id, binKey)
              ? "not-allowed"
              : isViewPermissionAllowed
              ? "pointer"
              : "not-allowed",
          }}
          onClick={(e) => {
            const binId = elem3[n] + "" + (n1 - 1);
            // Double-check restriction before opening
            if (this.isRestricted(BinStatus && BinStatus.group_type_id, binId)) {
              console.log('[C30] Click blocked - bin is restricted:', binId);
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            this.openbin(binId, binType, pm_id);
          }}
        >
          <Tooltip key={elem3[n] + "" + (n1 - 1)} title={statusTitle}>
            <div
              id={elem3[n] + "" + (n1 - 1)}
              className={statusClass}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
                borderRadius: '4px',
                                                                        // Apply visual styling for column-restricted bins
                                                                        backgroundColor: this.isRestrictedByColumnMapping(elem3[n] + "" + (n1 - 1)) ? '#FFE0B2' : 'transparent',
                                                                        border: this.isRestrictedByColumnMapping(elem3[n] + "" + (n1 - 1)) ? '2px solid #FF9800' : 'none',
              }}
            >
              {this.isRestricted(BinStatus && BinStatus.group_type_id, binKey) && (
                <LockIcon fontSize="12px" />
              )}
              &nbsp;{elem3[n] + "" + (n1 - 1)}
            </div>
          </Tooltip>
        </td>
      );
    }
    if (n === 1 && n1 === 6) {
      return (
        <td
          key={binKey}
          rowSpan={3}
          style={{
            padding: "4px",
            width: "85px",
            height: "140px",
            pointerEvents: this.isRestricted(
              BinStatus && BinStatus.group_type_id,
              binKey
            )
              ? "none"
              : isViewPermissionAllowed
              ? "auto"
              : "none",
            cursor: this.isRestricted(BinStatus && BinStatus.group_type_id, binKey)
              ? "not-allowed"
              : isViewPermissionAllowed
              ? "pointer"
              : "not-allowed",
          }}
          onClick={(e) => {
            const binId = elem3[n] + "" + (n1 - 1);
            // Double-check restriction before opening
            if (this.isRestricted(BinStatus && BinStatus.group_type_id, binId)) {
              console.log('[C30] Click blocked - bin is restricted:', binId);
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            this.openbin(binId, binType, pm_id);
          }}
        >
          <Tooltip key={elem3[n] + "" + (n1 - 1)} title={statusTitle}>
            <div
              id={elem3[n] + "" + (n1 - 1)}
              className={statusClass}
              style={{
                height: "140px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
                borderRadius: '4px',
                                                                        // Apply visual styling for column-restricted bins
                                                                        backgroundColor: this.isRestrictedByColumnMapping(elem3[n] + "" + (n1 - 1)) ? '#FFE0B2' : 'transparent',
                                                                        border: this.isRestrictedByColumnMapping(elem3[n] + "" + (n1 - 1)) ? '2px solid #FF9800' : 'none',
              }}
            >
              {this.isRestricted(BinStatus && BinStatus.group_type_id, binKey) && (
                <LockIcon fontSize="12px" />
              )}
              &nbsp;{elem3[n] + "" + (n1 - 1)}
            </div>
          </Tooltip>
        </td>
      );
    }
    if (n === 1 && n1 === 9) {
      return (
        <td
          key={binKey}
          className={isdisabledDoor ? disableClass : undefined}
          rowSpan={3}
          style={{
            padding: "4px",
            width: "85px",
            height: "140px",
            pointerEvents: this.isRestricted(
              BinStatus && BinStatus.group_type_id,
              binKey
            )
              ? "none"
              : isViewPermissionAllowed
              ? "auto"
              : "none",
            cursor: this.isRestricted(BinStatus && BinStatus.group_type_id, binKey)
              ? "not-allowed"
              : isViewPermissionAllowed
              ? "pointer"
              : "not-allowed",
          }}
          onClick={(e) => {
            const binId = elem3[n] + "" + (n1 - 3);
            // Double-check restriction before opening
            if (this.isRestricted(BinStatus && BinStatus.group_type_id, binId)) {
              console.log('[C30] Click blocked - bin is restricted:', binId);
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            this.openbin(binId, binType, pm_id);
          }}
        >
          <Tooltip key={elem3[n] + "" + (n1 - 3)} title={statusTitle}>
            <div
              id={elem3[n] + "" + (n1 - 3)}
              className={statusClass}
              style={{
                height: "140px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
                borderRadius: '4px',
                                                                        // Apply visual styling for column-restricted bins
                                                                        backgroundColor: this.isRestrictedByColumnMapping(elem3[n] + "" + (n1 - 3)) ? '#FFE0B2' : 'transparent',
                                                                        border: this.isRestrictedByColumnMapping(elem3[n] + "" + (n1 - 3)) ? '2px solid #FF9800' : 'none',
              }}
            >
              {this.isRestricted(BinStatus && BinStatus.group_type_id, binKey) && (
                <LockIcon fontSize="12px" />
              )}
              &nbsp;{elem3[n] + "" + (n1 - 3)}
            </div>
          </Tooltip>
        </td>
      );
    } else {
      return (
        n !== 1 &&
        n1 !== 1 && (
          <td
            style={{
              padding: "4px",
              width: "85px",
              pointerEvents: this.isRestricted(
                BinStatus && BinStatus.group_type_id,
                binKey
              )
                ? "none"
                : isViewPermissionAllowed
                ? "auto"
                : "none",
              cursor: this.isRestricted(
                BinStatus && BinStatus.group_type_id,
                binKey
              )
                ? "not-allowed"
                : isViewPermissionAllowed
                ? "pointer"
                : "not-allowed",
            }}
            onClick={(e) => {
              // Double-check restriction before opening
              if (this.isRestricted(BinStatus && BinStatus.group_type_id, binKey)) {
                console.log('[C30] Click blocked - bin is restricted:', binKey);
                e.preventDefault();
                e.stopPropagation();
                return;
              }
              this.openbin(binKey, binType, pm_id);
            }}
          >
            <Tooltip key={binKey} title={statusTitle}>
              <div
                id={elem3[n] + "" + (n1 + 1)}
                className={statusClass}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
                  borderRadius: '4px',
                  // Apply different styling for column-restricted bins
                  backgroundColor: this.isRestrictedByColumnMapping(elem3[n] + "" + (n1 + 1)) ? '#FFE0B2' : 'transparent',
                  border: this.isRestrictedByColumnMapping(elem3[n] + "" + (n1 + 1)) ? '2px solid #FF9800' : 'none',
                }}
              >
                {this.isRestricted(BinStatus && BinStatus.group_type_id, elem3[n] + "" + (n1 + 1)) && (
                  <LockIcon fontSize="12px" />
                )}
                &nbsp;{elem3[n] + "" + n1}
              </div>
            </Tooltip>
          </td>
        )
      );
    }
  };

  getBinIndexForMiddleColumn = (n, n1, elem3) => {
    let index = null;
    if (n === 1 && n1 === 0) {
      index = elem3[n] + "" + (n1 + 1);
    } else if (n === 1 && n1 === 2) {
      index = elem3[n] + "" + n1;
    } else if (n === 1 && [4, 5].includes(n1)) {
      index = elem3[n] + "" + (n1 - 1);
    } else if (n === 1 && n1 === 6) {
      index = elem3[n] + "" + (n1 - 1);
    } else if (n === 1 && n1 === 9) {
      index = elem3[n] + "" + (n1 - 3);
    } else {
      index =  n === 1 ? (elem3[n] + "" + n1) : (elem3[n] + "" + (n1 + 1));
    }
    return index;
  };

  render() {
    const BoxStatus = {
      ASSIGNED: "8f9c8e02-b9ee-4f29-aeea-670cef022663",
      STOCKED: "4ee90c0f-d4c3-4d53-8014-d7eac4ea2894",
      HOLD: "45593c2c-fc8c-4bf0-854e-e2bf759b7788",
      PICKED_UP: "00fe15e3-80b9-4e6f-9bf3-ad0c09a58c3e",
      CANCELLED: "8a994741-402e-4b18-a883-60da7fc94c7b",
      RETURNED: "198473ec-2e3f-42c8-a3f9-a0a3f8b4ae55",
      DEACTIVATED: "4f666da5-bfe0-4fb5-ad77-b92103881220",
    };
    // eslint-disable-next-line
    const {
      classes,
      BinStatus,
      box_position,
      deactivatedBins,
      isViewPermissionAllowed,
      t,
      ADAData,
      PatientID
    } = this.props;
    let elem3 = [];
    let side = box_position < 0 ? "L" : "R";
    if (side === "L") {
      let prevNextCount = this.getCurrentAndPreviousPosition(side);
      let previousExpansionCount =
        prevNextCount && prevNextCount.previousCount
          ? prevNextCount.previousCount
          : 0;
      elem3 = this.getColumns(
        box_position,
        prevNextCount && prevNextCount.currentCount,
        previousExpansionCount,
        side
      );
    } else {
      let prevNextCount = this.getCurrentAndPreviousPosition(side);
      let previousExpansionCount =
        prevNextCount && prevNextCount.previousCount
          ? prevNextCount.previousCount
          : 0;
      elem3 = this.getColumns(
        box_position,
        prevNextCount && prevNextCount.currentCount,
        previousExpansionCount,
        side
      );
    }
    return (
      <div key={this.props.prefix}>
        <div
          className={classes.ratingContainer}
          style={{
            marginBottom: "3px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <table
            style={{
              pointerEvents: isViewPermissionAllowed ? "auto" : "none",
            }}
          >
            <tbody>
            {nums1.map((n1) => {
               let doorInx = n1 + 1;
               const isdisabledDoor = Array.isArray(ADAData) && ADAData.some(function (item) {
                   return (
                       item &&
                       item.patient_id === PatientID &&
                       item.ada_compitible === true &&
                       ![7, 8, 9].includes(doorInx)
                   );
               });
               const disableClass = classes.disabledDoor;
              return (
                <tr key={n1}>
                  {nums3.map((n) => {
                    if (n !== 1) {
                      let binKey = this.getBinIndexForMiddleColumn(n, n1, elem3);
                      if (
                        BinStatus &&
                        BinStatus.length &&
                        BinStatus.length > 0
                      ) {
                        for (var i = 0; i < BinStatus.length; i++) {
                          let pm_id = BinStatus[i].id;
                          let bin_id = BinStatus[i].bin_id;
                          let type_id = BinStatus[i].type_id;
                          let isLockedBin = BinStatus[i].is_locked
                          if (bin_id === binKey) {
                            if (type_id === BoxStatus.STOCKED) {
                              return this.renderCell(
                                BinStatus[i],
                                "Stocked",
                                binKey,
                                pm_id,
                                isLockedBin ? classes.gridPurpleBin : classes.gridOrangeback,
                                t("Global.Prescriptions.Status.Stocked"),
                                disableClass,
                                isdisabledDoor
                              );
                            }
                            if (type_id === BoxStatus.ASSIGNED) {
                              return this.renderCell(
                                BinStatus[i],
                                "Assigned",
                                binKey,
                                pm_id,
                                isLockedBin ? classes.gridPurpleBin : classes.gridBlueback,
                                t("Global.Prescriptions.Status.Assigned"),
                                disableClass,
                                isdisabledDoor
                              );
                            }
                            if (type_id === BoxStatus.HOLD) {
                              return this.renderCell(
                                BinStatus[i],
                                "Hold",
                                binKey,
                                pm_id,
                                isLockedBin ? classes.gridPurpleBin : classes.gridSkyblueback,
                                t("Global.Prescriptions.Status.Hold"),
                                disableClass,
                                isdisabledDoor
                              );
                            }
                          }
                        }
                        if (
                          deactivatedBins &&
                          deactivatedBins.length &&
                          deactivatedBins.length > 0 &&
                          deactivatedBins.findIndex(
                            (D) => D === binKey
                          ) > -1
                        ) {
                          return (
                            <td
                              key={binKey}
                              style={{
                                padding: "4px",
                                width: "85px",
                                pointerEvents: this.isRestricted(
                                  BinStatus[i] && BinStatus[i].group_type_id
                                )
                                  ? "none"
                                  : isViewPermissionAllowed
                                  ? "auto"
                                  : "none",
                                cursor: this.isRestricted(
                                  BinStatus[i] && BinStatus[i].group_type_id
                                )
                                  ? "not-allowed"
                                  : isViewPermissionAllowed
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                              onClick={(e) => {
                                // Double-check restriction before opening
                                if (this.isRestricted(BinStatus && BinStatus.group_type_id, binKey)) {
                                  console.log('[C30] Click blocked - bin is restricted:', binKey);
                                  e.preventDefault();
                                  e.stopPropagation();
                                  return;
                                }
                                this.openbin(binKey, null, null);
                              }}
                            >
                              <Tooltip title="DEACTIVATE">
                                <div
                                  id={binKey}
                                  className={classes.gridRedback}
                                  style={{
                                                                        // Apply visual styling for column-restricted bins
                                                                        backgroundColor: this.isRestrictedByColumnMapping(binKey) ? '#FFE0B2' : 'transparent',
                                                                        border: this.isRestrictedByColumnMapping(binKey) ? '2px solid #FF9800' : 'none',
                                  }}
                                >
                                  {
                                    // Column mapping: show lock when restricted (priority over status)
                                    (this.isRestrictedByColumnMapping(binKey) || this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, binKey))
                                      ? <LockIcon fontSize="12px" /> : null
                                  }
                                  &nbsp;{binKey}
                                </div>
                              </Tooltip>
                            </td>
                          );
                        }
                        return this.renderCell(
                          BinStatus[i],
                          "Available",
                          binKey,
                          null,
                          classes.gridback,
                          t("Global.Prescriptions.Status.Available"),
                          disableClass,
                          isdisabledDoor
                        );
                      } else {
                        return this.renderCell(
                          BinStatus[i],
                          "Available",
                          binKey,
                          null,
                          classes.gridback,
                          t("Global.Prescriptions.Status.Available"),
                          disableClass,
                          isdisabledDoor
                        );
                      }
                    } else {
                      let binKey = this.getBinIndexForMiddleColumn(n, n1, elem3);
                      if (
                        BinStatus &&
                        BinStatus.length &&
                        BinStatus.length > 0
                      ) {
                        for (var j = 0; j < BinStatus.length; j++) {
                          let pm_id = BinStatus[j].id;
                          let bin_id = BinStatus[j].bin_id;
                          let type_id = BinStatus[j].type_id;
                          let isLockedBin = BinStatus[j].is_locked;
                          if (bin_id === binKey) {
                            if (type_id === BoxStatus.STOCKED) {
                              return this.renderMiddleColumnCells(
                                n,
                                n1,
                                elem3,
                                BinStatus[j],
                                "Stocked",
                                binKey,
                                pm_id,
                                isLockedBin ? classes.gridPurpleBin : classes.gridOrangeback,
                                t("Global.Prescriptions.Status.Stocked"),
                                disableClass,
                                isdisabledDoor,
                              );
                            }
                            if (type_id === BoxStatus.ASSIGNED) {
                              return this.renderMiddleColumnCells(
                                n,
                                n1,
                                elem3,
                                BinStatus[j],
                                "Assigned",
                                binKey,
                                pm_id,
                                isLockedBin ? classes.gridPurpleBin : classes.gridBlueback,
                                t("Global.Prescriptions.Status.Assigned"),
                                disableClass,
                                isdisabledDoor,
                              );
                            }
                            if (type_id === BoxStatus.HOLD) {
                              return this.renderMiddleColumnCells(
                                n,
                                n1,
                                elem3,
                                BinStatus[j],
                                "Hold",
                                binKey,
                                pm_id,
                                isLockedBin ? classes.gridPurpleBin : classes.gridSkyblueback,
                                t("Global.Prescriptions.Status.Hold"),
                                disableClass,
                                isdisabledDoor,
                              );
                            }
                          }
                        }
                        if (
                          deactivatedBins &&
                          deactivatedBins.length &&
                          deactivatedBins.length > 0 &&
                          deactivatedBins.findIndex(
                            (D) =>
                              D ===
                              this.getBinIndexForMiddleColumn(n, n1, elem3)
                          ) > -1
                        ) {
                          if (n === 1 && n1 === 0) {
                            const deactivatedBinKey = elem3[n] + "" + (n1 + 1);
                            return (
                              <td
                                key={deactivatedBinKey}
                                className={isdisabledDoor ? disableClass : undefined}
                                rowSpan={2}
                                style={{
                                  padding: "4px",
                                  width: "85px",
                                  height: "90px",
                                  pointerEvents: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "none"
                                    : isViewPermissionAllowed
                                    ? "auto"
                                    : "none",
                                  cursor: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "not-allowed"
                                    : isViewPermissionAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                onClick={(e) => {
                                  // Double-check restriction before opening
                                  if (this.isRestricted(BinStatus && BinStatus.group_type_id, deactivatedBinKey)) {
                                    console.log('[C30] Click blocked - bin is restricted:', deactivatedBinKey);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return;
                                  }
                                  this.openbin(deactivatedBinKey, null, null);
                                }}
                              >
                                <Tooltip
                                  key={deactivatedBinKey}
                                  title={"DEACTIVATE"}
                                >
                                  <div
                                    id={deactivatedBinKey}
                                    className={classes.gridRedback}
                                    style={{
                                      height: "90px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {
                                      // Column mapping: show lock when restricted (priority over status)
                                      (this.isRestrictedByColumnMapping(deactivatedBinKey) || this.isRestricted(BinStatus[j] && BinStatus[j].group_type_id, deactivatedBinKey))
                                        ? <LockIcon fontSize="12px" /> : null
                                    }
                                    &nbsp;{deactivatedBinKey}
                                  </div>
                                </Tooltip>
                              </td>
                            );
                          }
                          if (n === 1 && n1 === 2) {
                            const deactivatedBinKey = elem3[n] + "" + n1;
                            return (
                              <td
                                key={deactivatedBinKey}
                                className={isdisabledDoor ? disableClass : undefined}
                                rowSpan={2}
                                style={{
                                  padding: "4px",
                                  width: "85px",
                                  height: "90px",
                                  pointerEvents: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "none"
                                    : isViewPermissionAllowed
                                    ? "auto"
                                    : "none",
                                  cursor: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "not-allowed"
                                    : isViewPermissionAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                onClick={(e) => {
                                  // Double-check restriction before opening
                                  if (this.isRestricted(BinStatus && BinStatus.group_type_id, deactivatedBinKey)) {
                                    console.log('[C30] Click blocked - bin is restricted:', deactivatedBinKey);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return;
                                  }
                                  this.openbin(deactivatedBinKey, null, null);
                                }}
                              >
                                <Tooltip
                                  key={deactivatedBinKey}
                                  title={"DEACTIVATE"}
                                >
                                  <div
                                    id={deactivatedBinKey}
                                    className={classes.gridRedback}
                                    style={{
                                      height: "90px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {
                                      // Column mapping: show lock when restricted (priority over status)
                                      (this.isRestrictedByColumnMapping(deactivatedBinKey) || this.isRestricted(BinStatus[j] && BinStatus[j].group_type_id, deactivatedBinKey))
                                        ? <LockIcon fontSize="12px" /> : null
                                    }
                                    &nbsp;{deactivatedBinKey}
                                  </div>
                                </Tooltip>
                              </td>
                            );
                          }
                          if (n === 1 && [4, 5].includes(n1)) {
                            const deactivatedBinKey = elem3[n] + "" + (n1 - 1);
                            return (
                              <td
                                key={deactivatedBinKey}
                                className={isdisabledDoor ? disableClass : undefined}
                                style={{
                                  padding: "4px",
                                  width: "85px",
                                  pointerEvents: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "none"
                                    : isViewPermissionAllowed
                                    ? "auto"
                                    : "none",
                                  cursor: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "not-allowed"
                                    : isViewPermissionAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                onClick={(e) => {
                                  // Double-check restriction before opening
                                  if (this.isRestricted(BinStatus && BinStatus.group_type_id, deactivatedBinKey)) {
                                    console.log('[C30] Click blocked - bin is restricted:', deactivatedBinKey);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return;
                                  }
                                  this.openbin(deactivatedBinKey, null, null);
                                }}
                              >
                                <Tooltip
                                  key={deactivatedBinKey}
                                  title={"DEACTIVATE"}
                                >
                                  <div
                                    id={deactivatedBinKey}
                                    className={classes.gridRedback}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {
                                      // Column mapping: show lock when restricted (priority over status)
                                      (this.isRestrictedByColumnMapping(deactivatedBinKey) || this.isRestricted(BinStatus[j] && BinStatus[j].group_type_id, deactivatedBinKey))
                                        ? <LockIcon fontSize="12px" /> : null
                                    }
                                    &nbsp;{deactivatedBinKey}
                                  </div>
                                </Tooltip>
                              </td>
                            );
                          }
                          if (n === 1 && n1 === 6) {
                            const deactivatedBinKey = elem3[n] + "" + (n1 - 1);
                            return (
                              <td
                                key={deactivatedBinKey}
                                rowSpan={3}
                                style={{
                                  padding: "4px",
                                  width: "85px",
                                  height: "140px",
                                  pointerEvents: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "none"
                                    : isViewPermissionAllowed
                                    ? "auto"
                                    : "none",
                                  cursor: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "not-allowed"
                                    : isViewPermissionAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                onClick={(e) => {
                                  // Double-check restriction before opening
                                  if (this.isRestricted(BinStatus && BinStatus.group_type_id, deactivatedBinKey)) {
                                    console.log('[C30] Click blocked - bin is restricted:', deactivatedBinKey);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return;
                                  }
                                  this.openbin(deactivatedBinKey, null, null);
                                }}
                              >
                                <Tooltip
                                  key={deactivatedBinKey}
                                  title={"DEACTIVATE"}
                                >
                                  <div
                                    id={deactivatedBinKey}
                                    className={classes.gridRedback}
                                    style={{
                                      height: "140px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {
                                      // Column mapping: show lock when restricted (priority over status)
                                      (this.isRestrictedByColumnMapping(deactivatedBinKey) || this.isRestricted(BinStatus[j] && BinStatus[j].group_type_id, deactivatedBinKey))
                                        ? <LockIcon fontSize="12px" /> : null
                                    }
                                    &nbsp;{deactivatedBinKey}
                                  </div>
                                </Tooltip>
                              </td>
                            );
                          }
                          if (n === 1 && n1 === 9) {
                            const deactivatedBinKey = elem3[n] + "" + (n1 - 3);
                            return (
                              <td
                                key={deactivatedBinKey}
                                rowSpan={3}
                                style={{
                                  padding: "4px",
                                  width: "85px",
                                  height: "140px",
                                  pointerEvents: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "none"
                                    : isViewPermissionAllowed
                                    ? "auto"
                                    : "none",
                                  cursor: this.isRestricted(
                                    BinStatus[j] &&
                                      BinStatus[j].group_type_id
                                  )
                                    ? "not-allowed"
                                    : isViewPermissionAllowed
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                                onClick={(e) => {
                                  // Double-check restriction before opening
                                  if (this.isRestricted(BinStatus && BinStatus.group_type_id, deactivatedBinKey)) {
                                    console.log('[C30] Click blocked - bin is restricted:', deactivatedBinKey);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return;
                                  }
                                  this.openbin(deactivatedBinKey, null, null);
                                }}
                              >
                                <Tooltip
                                  key={deactivatedBinKey}
                                  title={"DEACTIVATE"}
                                >
                                  <div
                                    id={deactivatedBinKey}
                                    className={classes.gridRedback}
                                    style={{
                                      height: "140px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {
                                      // Column mapping: show lock when restricted (priority over status)
                                      (this.isRestrictedByColumnMapping(deactivatedBinKey) || this.isRestricted(BinStatus[j] && BinStatus[j].group_type_id, deactivatedBinKey))
                                        ? <LockIcon fontSize="12px" /> : null
                                    }
                                    &nbsp;{deactivatedBinKey}
                                  </div>
                                </Tooltip>
                              </td>
                            );
                          } else {
                            const deactivatedBinKey = this.getBinIndexForMiddleColumn(n, n1, elem3);
                            return (
                              n !== 1 &&
                              n1 !== 1 && (
                                <td
                                  style={{
                                    padding: "4px",
                                    width: "85px",
                                    pointerEvents: this.isRestricted(
                                      BinStatus[j] &&
                                        BinStatus[j].group_type_id
                                    )
                                      ? "none"
                                      : isViewPermissionAllowed
                                      ? "auto"
                                      : "none",
                                    cursor: this.isRestricted(
                                      BinStatus[j] &&
                                        BinStatus[j].group_type_id
                                    )
                                      ? "not-allowed"
                                      : isViewPermissionAllowed
                                      ? "pointer"
                                      : "not-allowed",
                                  }}
                                  onClick={(e) => {
                                  // Double-check restriction before opening
                                  if (this.isRestricted(BinStatus && BinStatus.group_type_id, deactivatedBinKey)) {
                                    console.log('[C30] Click blocked - bin is restricted:', deactivatedBinKey);
                                    e.preventDefault();
                                    e.stopPropagation();
                                    return;
                                  }
                                  this.openbin(deactivatedBinKey, null, null);
                                }}
                                >
                                  <Tooltip key={deactivatedBinKey} title={"DEACTIVATE"}>
                                    <div
                                      id={deactivatedBinKey}
                                      className={classes.gridRedback}
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {
                                        // Column mapping: show lock when restricted (priority over status)
                                        (this.isRestrictedByColumnMapping(deactivatedBinKey) || this.isRestricted(BinStatus[j] && BinStatus[j].group_type_id, deactivatedBinKey))
                                          ? <LockIcon fontSize="12px" /> : null
                                      }
                                      &nbsp;{deactivatedBinKey}
                                    </div>
                                  </Tooltip>
                                </td>
                              )
                            );
                          }
                        }
                        return this.renderMiddleColumnCells(
                          n,
                          n1,
                          elem3,
                          BinStatus[j],
                          "Available",
                          binKey,
                          null,
                          classes.gridback,
                          t("Global.Prescriptions.Status.Available"),
                          disableClass,
                          isdisabledDoor,
                        );
                      } else {
                        return this.renderMiddleColumnCells(
                          n,
                          n1,
                          elem3,
                          BinStatus[i],
                          "Available",
                          binKey,
                          null,
                          classes.gridback,
                          t("Global.Prescriptions.Status.Available"),
                          disableClass,
                          isdisabledDoor,
                        );
                      }
                    }
                  })}
                </tr>
              );
            })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(C30Layout));



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/C30.layout.js